import React from "react"
import { Row, Col } from 'antd';
import './style.scss'

const arrs = [
  { name: 'Yinpeng Dong', con: 'Tsinghua University', type: "F", img: 'https://img.alicdn.com/imgextra/i4/O1CN01mjINny1bM98RbjXBb_!!6000000003450-2-tps-260-260.png' },
  { name: 'Tianyu Pang', con: 'Tsinghua University', type: "F", img: 'https://img.alicdn.com/imgextra/i4/O1CN01l9yF631WSUXfk1I8W_!!6000000002787-2-tps-260-260.png' },
  { name: 'Xiao Yang ', con: 'Tsinghua University', type: "F", img: 'https://img.alicdn.com/imgextra/i4/O1CN01fHAfBK1SE3b6kI6sh_!!6000000002214-2-tps-260-260.png' },
  { name: 'Dingcheng Yang', con: 'Tsinghua University', type: "F", img: 'https://img.alicdn.com/imgextra/i3/O1CN01BJ3jeE1LUomiSrDXT_!!6000000001303-2-tps-234-234.png' },
  { name: 'Xiaofeng Mao', con: 'Alibaba', type: "F", img: 'https://img.alicdn.com/imgextra/i4/O1CN012n5Fk31IEq7ZHa3oH_!!6000000000862-0-tps-3404-3403.jpg' },
  { name: 'Yuefeng Chen', con: 'Alibaba', type: "F", img: 'https://img.alicdn.com/imgextra/i2/O1CN01i73yxB1rZutxqkT63_!!6000000005646-0-tps-336-342.jpg' },
  { name: 'Eric Wong', con: 'MIT', type: "F", img: 'https://img.alicdn.com/imgextra/i4/O1CN016FSgVr1pjsH4ONzV8_!!6000000005397-2-tps-260-260.png' },
  { name: 'Zico Kolter', con: 'CMU', type: "F", img: 'https://img.alicdn.com/imgextra/i3/O1CN01Co9fRO1IMASHDnWdw_!!6000000000878-2-tps-260-260.png' },
  { name: 'Yuan He', con: 'Alibaba', type: "F", img: 'https://img.alicdn.com/imgextra/i3/O1CN01SxwjpW1NeYQpL1dT2_!!6000000001595-2-tps-260-260.png' },
]

export default function Organizers() {
  return <div className="page-organizers">
    <div className="organizers-title">Organizers</div>
    <Row className="list-ul">
      {arrs.map((item, index) => (<Col xl={3} sm={12} span={24} key={index} className="list-li">
        <div className="list-two">
          <img src={item.img} alt="" />
          <div className="pro-div">
            <span>{item.name}</span>
            <b className={item.type === "F" ? "b" : ''} />
            <div>
              <div className="item-con" dangerouslySetInnerHTML={{ __html: item.con }} />
            </div>
          </div>
        </div>
      </Col>))}
    </Row>
  </div>
}
